import Component from "../classes/Component"
import each from 'lodash/each'
// import "lightgallery.js"
import lightGallery from 'lightgallery';

import { app } from '../utils/store'

export default class LightBox{
    constructor({element}){
        this.element = element,
        this.elements = {
            images: element.querySelectorAll('img'),
        }

        this.create(this.element)
    }
    
    create = (entry) => {
        // console.log(entry)

        this.lighbox = lightGallery(entry, {
            licenseKey:	"0000-0000-000-0000",
            // mode: 'lg-fade',
            // startClass: 'lg-start-fade',
            selector: 'img',
            closeOnTap: true,
            mousewheel: true,
            keypress: true,
            controls: false,
            download: false,
            counter: true,
            enableDrag: false,
            enableTouch: false,
            enableSwipe: true,
            // subHtmlSelectorRelative: true,
            subHtml: false,
            useLeft: true,
            hideControlOnEnd: true,
        })

        // console.log(this.lighbox)

        // if(entry){
        //     console.log(this.lightbox.outer.selector)
        //     entry.addEventListener('onBeforeOpen', () => {
        //         // this.header.classList.add('lg-active')
        //         // document.querySelector('body').classList.toggle('overflow-hidden')
        //     })
            
        //     entry.addEventListener('onBeforeClose', () => {
        //         // this.header.classList.remove('lg-active')
        //         // document.querySelector('body').classList.toggle('overflow-hidden')
        //     })

        //     // each(this.elements.image, (image) => {
        //     //     image.onclick = (event) => this.onClick(event)
        //     // })
        // }
    }

    onClick = (event) => {
        app.root.classList.add('lg-materials')

        var target = event.target.getAttribute('data-src')
        // document.querySelector('.lightbox [data-src="' + target + '"').click()
        // document.body.classList.add('overflow-hidden')
        // document.body.classList.add('modal-active')
    }
}
